export const IconsSize = {
    mobile: {
        xxs: '0.7vw',
        xs: "0.8vw",//"16"
        sm: "1vw",//"20"
        md: "1.8vw",
        lg: "32",
        xl: "40",
    },

    tablet: {
        xxs: '0.7vw',
        xs: "0.8vw",//"16"
        sm: "1vw",//"20"
        md: "1.8vw",
        lg: "32",
        xl: "40",
    },

    laptop: {
        xxs: '0.7vw',
        xs: "0.8vw",//"16"
        sm: "1vw",//"20"
        md: "1.8vw",
        lg: "10",
        xl: "40",
    },

    desktop: {
        xxs: '10px',// In Cascais 32.0px
        xs: "12px", // In Cascais 48.0px
        sm: "14px", // In Cascais 52.0px                               
        md: "16px",// In Cascais 64.0px
        lg: "20px",// In Cascais 88.0px
        xl: "24px",// In Cascais 96.0px
        xxl: "30px",// In Cascais 104.0px
    },

    videowall: {
        xxs: '0.418vw',// In Cascais 32.0px
        xs: "0.625vw", // In Cascais 48.0px
        sm: "0.678vw", // In Cascais 52.0px                               
        md: "0.834vw",// In Cascais 64.0px
        lg: "1.146vw",// In Cascais 88.0px
        xl: "1.25vw",// In Cascais 96.0px
        xxl: "1.355vw",// In Cascais 104.0px
    }
}